import { QuoteBindingSearchResponse } from '@lio/api-types';
import { ArrayItem } from '@utils/commonTypes';

export type QuoteBinding = ArrayItem<QuoteBindingSearchResponse['items']>;

export type BindingStatus = QuoteBinding['status'];

export const QuoteBindingStatus: Record<BindingStatus, BindingStatus> = {
  Pending: 'Pending',
  InProgress: 'InProgress',
  Failed: 'Failed',
  Succeeded: 'Succeeded',
};
